import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom"
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router';
import { useDispatch } from 'react-redux';
import { CREATE_RESUME, CHOOSE_COLOR, CHOOSE_EDITOR ,HOME_URL, TEMPLATE_IDS, HEADING_LINK } from '../constants/constants';
import { createNewResume4rmShowcase, updateTemplate } from '../services/actions/actions';
import PageLoader from './common/PageLoader';
import WpAPI from '../WpApi';

// import ChooseEditor from './ChooseEditor';


const CreateResumeWithShowcase = (props) => {
  
  const [redirectTo, setRedirectTo] = useState(false);
  const [linkedinLightBox, setLinkedinLightBox] = useState(true);
  const params = useParams()
  let h = useHistory();
  const dispatch = useDispatch()
  const gotoPage = (url) => {
    history.pushState(null, CHOOSE_COLOR);
    h.push(url);
  };
  useEffect(() => {
    const showcase_id = params.showcase_id
    localStorage.setItem('showcase_id',showcase_id)
    //getShowcase profile
    WpAPI.getShowCaseResume(showcase_id, (resume) => {
        // localStorage.setItem('showcase', JSON.stringify(resume))
        // localStorage.setItem('selected_color',resume.active_color)
        // localStorage.setItem('selected_template',resume.active_template)
        // if (resume.custom_template_color.length) {
        //   localStorage.setItem('selected_custom_color', resume.custom_template_color)
        // }
        dispatch(createNewResume4rmShowcase(resume))
        setTimeout(() => {
            setRedirectTo(true);
        }, 2000);
    });
    
  }, []);


  if (redirectTo) { return <Redirect to={HEADING_LINK} /> }
  return (<><PageLoader />
  </>);
}

export default CreateResumeWithShowcase;